module.exports = __webpack_public_path__ + "img/mission-good-for-you.jpg?b1301bc6deafd1297527e2b32e7a36f4";